import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import Portal from 'react-portal';

import { colors } from '../../styles';
import { GraphToolTipContent, ToolTipContent } from './';

export interface Props {
  children: any;
  className?: string;
  isOpen?: boolean;
  graph?: boolean;
  svg?: boolean;
  tooltip: any;
  clickable?: boolean;
}

export interface State {
  isOpen: boolean;
}

class ToolTip extends React.Component<Props, State> {
  static defaultProps: Partial<Props> = {
    graph: false,
    isOpen: false,
    clickable: false,
  };

  public state: State = {
    isOpen: false,
  };

  private activator = null;

  public render() {
    const { children, className, graph, tooltip, svg, clickable } = this.props;
    const isOpen = this.state.isOpen || this.props.isOpen;
    const Container = svg ? 'g' : 'div';
    const ToolTipWrapper = graph ? GraphToolTipContent : ToolTipContent;

    return (
      <Container
        className={className}
        onMouseEnter={this.handleOpenTooltip}
        onMouseLeave={this.handleCloseTooltip}
      >
        {isOpen && (
          <Portal isOpened={isOpen}>
            <ToolTipWrapper activator={this.activator} clickable={clickable}>
              {tooltip}
            </ToolTipWrapper>
          </Portal>
        )}
        <Container
          className="activator"
          ref={el => {
            this.activator = el;
          }}
        >
          {children}
        </Container>
      </Container>
    );
  }

  private handleCloseTooltip = e => {
    if (!this.props.clickable) {
      this.setState({ isOpen: false });
    }
  };

  private handleOpenTooltip = e => {
    if (!this.props.clickable) {
      this.setState({ isOpen: true });
    }
  };
}

export default styled(ToolTip)`
  position: relative;

  .content,
  .activator {
    display: inline-block;
  }
  .content {
    position: absolute;
    background: ${colors.black};
    border-radius: 4px;
    color: #fff;
    padding: 1rem 1.3rem;
    pointer-events: none;
  }
`;
